import { Component, h, Prop } from "@stencil/core";
import { ProfileFlyoutContentSectionProps } from "./f-profile-flyout-content-section-model";
import classNames from "classnames";

@Component({
  tag: "f-profile-flyout-content-section",
  styleUrl: "f-profile-flyout-content-section.scss",
  shadow: true,
})
export class ProfileFlyoutContentSection {
  @Prop() variant: ProfileFlyoutContentSectionProps["variant"];
  @Prop() first: ProfileFlyoutContentSectionProps["first"];
  @Prop() last: ProfileFlyoutContentSectionProps["last"];

  render() {
    const sectionVariant =
      this.last && !Boolean(this.variant)
        ? "no-border"
        : this.variant || "with-border";
    const sectionClass = classNames(
      "profile-flyout-content__section",
      {
        [`profile-flyout-content__section--${sectionVariant}`]: sectionVariant,
      },
      {
        [`profile-flyout-content__section--first`]: this.first,
      },
      {
        [`profile-flyout-content__section--last`]: this.last,
      }
    );

    return (
      <div class={sectionClass}>
        <slot />
      </div>
    );
  }
}
